


















import Vue from "vue";

import iwInputPrice from "@/encoding/components/buildingBlocks/InputPrice.vue";

export default Vue.extend({
    components: {
        iwInputPrice: iwInputPrice
    },
    data: function() {
        return {
            pathInStore: "transaction.sale.pricePerSqm",
        };
    },
    computed: {
        isOptional:function(): boolean {
            return (["LAND"].indexOf(this.getPropertyType()) === - 1 && this.$store.getters["FormModule/getValue"]("transaction.type") === "FOR_SALE");
        },
        isDisplayed: function(): boolean {
            return (this.$store.getters["FormModule/getValue"]("transaction.type") === "FOR_SALE");
        },
        pricePerSqm: function(): string {
            return this.$store.getters["FormModule/getValue"](this.pathInStore) ?? "";
        },
    },
    mounted: function() {
        if (!this.isDisplayed) {
            this.$store.commit("FormModule/deleteValue", this.pathInStore);
        }
    },
    methods: {
        updateValue: function(pricePerSqm: number): void {
            if (pricePerSqm === 0) {
                this.$store.commit("FormModule/deleteValue", this.pathInStore);
            } else {
                this.$store.dispatch("FormModule/addValue", {"path": this.pathInStore, "value": pricePerSqm});
            }
        }
    }
});
